import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaCardDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-rt-rabbitmq',
	templateUrl:'./RabbitMQPage.html',
	styles: [],
	styleUrls:['./RabbitMQPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
		WaCardDirective,
],
	standalone:true
})
export class RabbitMQPage
{
	mdContent_1177 = `For deployments that need durable messaging, multi-instance fan-out, or broker-managed persistence, add the RabbitMQ Comms module. Server-side Java publishes via AMQP to RabbitMQ fanout exchanges. Browser-side Angular connects directly to RabbitMQ via the Web STOMP plugin. Each group name maps to a fanout exchange — messages broadcast to every subscribed client.`;
}
